import React, { useCallback, useEffect, useState } from "react";
import * as Yup from "yup";
import useStyles from "src/views/viewGuardia/listas/New/useStyles";
import {
  Box,
  Card,
  CardContent,
  CardHeader,
  Checkbox,
  Divider,
  FormControlLabel,
  Grid,
  List,
  ListItem,
  ListItemText,
  MenuItem,
  TextField,
  ListItemIcon,
  Typography,
  ListItemSecondaryAction,
  IconButton,
  CircularProgress,
  CardActions,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  DialogContentText,
} from "@material-ui/core";
import PerfectScrollbar from "react-perfect-scrollbar";
import UploadIcon from "src/assets/img/uploadIcon.svg";
import {
  Apartment,
  CloudUpload,
  Eco,
  FileCopy,
  Folder,
  Save,
  VpnKey,
  ZoomIn,
} from "@material-ui/icons";
import { Formik } from "formik";
import { StyledButton } from "src/components/CustomButtons/TgButton";
import clsx from "clsx";
import { useSnackbar } from "notistack";
import { useDropzone } from "react-dropzone";
import bytesToSize from "src/utils/bytesToSize";
import { useSelector } from "react-redux";
import { selectConjunto } from "src/redux/slices/complexSlice";
import DeleteLogo from "./DeleteLogo";
import {
  deleteLogoFile,
  getLogoFile,
  getConfigFacturacion,
  saveLogoFile,
  updateConfigFacturacion,
  createConfigFacturacion,
  updateConjunto,
} from "../services/firestore";

const ConfigEmpresa = () => {
  const classes = useStyles();
  const conjunto = useSelector(selectConjunto);
  const { enqueueSnackbar } = useSnackbar();
  const [openDialogPass, setOpenDialogPass] = useState(false);
  const [configFacturacion, setConfigFacturacion] = useState({});
  const [loading, setLoading] = useState(false);
  const [loadingFile, setLoadingFile] = useState(false);
  const [uploadFile, setUploadFile] = useState(null);
  const [label, setLabel] = useState("Cargar archivo");
  const [filesLogo, setFilesLogo] = useState([]);
  const [files, setFiles] = useState([]);
  const [sign, setSign] = useState("");

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const parkeyPromise = new Promise((resolve, reject) => {
          getConfigFacturacion(
            {
              next: (res) => {
                setConfigFacturacion(res.data());
                resolve();
              },
              error: (err) => {
                enqueueSnackbar(
                  "Error al obtener datos, ¡Inténtelo de nuevo más tarde!",
                  {
                    variant: "error",
                  }
                );
                reject(err);
              },
            },
            conjunto.id
          );
        });
        const logoPromise = new Promise((resolve) => {
          getLogoFile(conjunto.id, (snapshot) => {
            const data = snapshot.data();
            setFilesLogo(data?.billLogo || []);
            setLabel(
              data?.Images?.length ? "Actualizar archivo" : "Cargar archivo"
            );
            resolve();
          });
        });
        await Promise.all([parkeyPromise, logoPromise]);
      } catch (error) {
        enqueueSnackbar("Error al cargar la información.", {
          variant: "info",
        });
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [conjunto.id]);

  useEffect(() => {
    if (files.length > 0) {
      const file = files[0];
      const allowedExtensions = ["p12", "pfx", "cer"];
      const fileExtension = file.name.split(".").pop().toLowerCase();
      if (!allowedExtensions.includes(fileExtension)) {
        enqueueSnackbar("El archivo no es una firma electrónica válida.", {
          variant: "error",
        });
        setFiles([]);
      }
    }
  }, [files]);

  // Firma a Base64
  const processFile = (file) => {
    const reader = new FileReader();
    reader.readAsBinaryString(file);
    reader.onload = () => {
      const base64 = btoa(reader.result);
      setSign(base64);
    };
  };

  const handleFileUpload = (event) => {
    const File = event.target.filesLogo[0];
    const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5 MB
    if (File) {
      if (File.size > MAX_FILE_SIZE) {
        enqueueSnackbar(
          "No puede exceder los 5mb. El archivo es demasiado pesado",
          {
            variant: "error",
          }
        );
      } else {
        if (filesLogo.length > 0) {
          enqueueSnackbar("Se reemplazará el anterior logo", {
            variant: "info",
          });
        }
        setLabel("Editar archivo");
        setUploadFile(File);
      }
    }
  };

  const saveFileStorage = async () => {
    if (uploadFile) {
      setLoadingFile(true);
      try {
        if (filesLogo.length > 0) {
          await deleteLogoFile(filesLogo[0], conjunto);
          enqueueSnackbar("Logo reemplazado", {
            variant: "info",
          });
          setFilesLogo([]);
        }
        const url = await saveLogoFile(uploadFile, conjunto.id);
        enqueueSnackbar("Archivo subido con éxito", {
          variant: "success",
        });
        setFilesLogo([url]);
        setUploadFile(null);
        setLoadingFile(false);
      } catch (error) {
        setLoadingFile(false);
        enqueueSnackbar(
          "Ha ocurrido un error inesperado, vuelve a intentarlo",
          {
            variant: "error",
          }
        );
      }
    }
  };

  const handleDrop = useCallback((acceptedFiles, rejectedFiles) => {
    if (rejectedFiles.length > 0) {
      enqueueSnackbar("Solo se puede cargar un archivo.", {
        variant: "error",
      });
    } else {
      setFiles(acceptedFiles);
      processFile(acceptedFiles[0]);
    }
  }, []);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop: handleDrop,
    maxFiles: 1,
  });

  const handleRemoveAll = () => {
    setFiles([]);
    setSign("");
  };

  const handleOpenDialog = () => {
    setOpenDialogPass(true);
  };

  const handleCloseDialog = () => {
    setOpenDialogPass(false);
  };

  return (
    <div>
      {loading ? (
        <Box display="flex" justifyContent="center" my={5}>
          <CircularProgress />
        </Box>
      ) : (
        <Formik
          initialValues={{
            ruc: configFacturacion?.ruc || "",
            direccion_matriz: configFacturacion?.direccion_matriz || "",
            razon_social: configFacturacion?.razon_social || "",
            phones: configFacturacion?.phones || "",
            nombre_comercial: configFacturacion?.nombre_comercial || "",
            establecimiento: configFacturacion?.establecimiento || "",
            correo: configFacturacion?.correo || "",
            iva: configFacturacion?.iva || 15,
            obligado_contabilidad:
              configFacturacion?.obligado_contabilidad || false,
            contribuyente_especial:
              configFacturacion?.contribuyente_especial || false,
            agente_retencion: configFacturacion?.agente_retencion || false,
            microenterprise: configFacturacion?.microenterprise || false,
            signPass: "",
          }}
          validationSchema={Yup.object({
            ruc: Yup.string()
              .required("El RUC es obligatorio")
              .matches(/^\d{13}$/, "El RUC debe tener 13 dígitos numéricos"),
            direccion_matriz: Yup.string()
              .required("La dirección matriz es obligatoria")
              .trim(),
            razon_social: Yup.string()
              .required("La razón social es obligatoria")
              .trim(),
            phones: Yup.string()
              .required("El teléfono es obligatorio")
              .matches(/^\+?\d{7,15}$/, "Teléfono inválido"),
            nombre_comercial: Yup.string()
              .required("El nombre comercial es obligatorio")
              .trim(),
            establecimiento: Yup.string()
              .required("El número de establecimiento es obligatorio")
              .matches(
                /^\d{3}$/,
                "El número de establecimiento debe tener 3 dígitos"
              ),
            correo: Yup.string()
              .email("Correo inválido")
              .required("El correo es obligatorio"),
            iva: Yup.number()
              .typeError("Debe ser un número")
              .min(0, "El IVA no puede ser negativo")
              .max(100, "El IVA no puede superar el 100%")
              .required("El IVA es obligatorio"),
            obligado_contabilidad: Yup.boolean(),
            contribuyente_especial: Yup.boolean(),
            agente_retencion: Yup.boolean(),
            microenterprise: Yup.boolean(),
          })}
          onSubmit={async (values) => {
            try {
              let dataFacturacion = {
                ...values,
                direccion_emisor: values.direccion_matriz,
              };
              if (files.length > 0) {
                dataFacturacion = {
                  ...dataFacturacion,
                  sign,
                  signPass: values.signPass,
                };
              } else {
                dataFacturacion.signPass = configFacturacion.signPass;
              }
              if (!configFacturacion) {
                dataFacturacion = { ...dataFacturacion, numSeq: 1 };
                await createConfigFacturacion(conjunto.id, dataFacturacion);
              } else {
                await updateConfigFacturacion(conjunto.id, dataFacturacion);
              }
              await updateConjunto(conjunto.id, dataFacturacion);
              enqueueSnackbar("Cambios guardados correctamente.", {
                variant: "success",
              });
              handleCloseDialog();
              handleRemoveAll();
            } catch (error) {
              enqueueSnackbar(
                "Error al guardar los datos, inténtelo nuevamente mas tarde.",
                {
                  variant: "error",
                }
              );
            }
          }}
        >
          {({
            values,
            handleChange,
            handleBlur,
            errors,
            touched,
            handleSubmit,
            setFieldValue,
          }) => (
            <form onSubmit={handleSubmit}>
              <Box mt={3}>
                <Card>
                  <CardHeader
                    title={
                      <span style={{ fontSize: "0.9rem" }}>
                        <Eco fontSize="small" /> Logo
                      </span>
                    }
                    style={{ paddingBottom: 9, paddingTop: 9 }}
                  />
                  <CardContent>
                    <Grid container spacing={2}>
                      <Grid
                        item
                        md={4}
                        xs={12}
                        className="overflow-auto order-last order-lg-first"
                      >
                        <Typography variant="h6">
                          <b> Logo Actual: </b>
                        </Typography>
                        <List
                          style={{
                            flexGrow: 1,
                            overflow: "auto",
                            width: "100%",
                          }}
                        >
                          {filesLogo.map((img, ind) => (
                            // eslint-disable-next-line react/no-array-index-key
                            <ListItem key={ind}>
                              <ListItemIcon>
                                <Folder />
                              </ListItemIcon>
                              <ListItemText primary="Logo" />
                              <ListItemSecondaryAction>
                                <IconButton onClick={() => window.open(img)}>
                                  <ZoomIn />
                                </IconButton>
                                <DeleteLogo
                                  conjunto={conjunto}
                                  setFiles={setFilesLogo}
                                  ind={ind}
                                  img={img}
                                />
                              </ListItemSecondaryAction>
                            </ListItem>
                          ))}
                        </List>
                        {filesLogo.length > 0 ? (
                          <Box style={{ marginTop: "auto", padding: "20%" }}>
                            <img
                              alt="Logo"
                              src={filesLogo}
                              style={{
                                width: 160,
                                height: 90,
                                objectFit: "contain",
                              }}
                            />
                          </Box>
                        ) : null}
                      </Grid>

                      <Grid
                        item
                        md={8}
                        xs={12}
                        className="text-center display-block order-first order-lg-last"
                      >
                        <img
                          width={200}
                          src={UploadIcon}
                          alt="Imagen de subida de archivos"
                          className="mb-4"
                        />
                        <br />
                        <Typography variant="h6">
                          <b> Agregue su logo facilmente. </b>
                        </Typography>
                        <Typography variant="h6" className="mb-4">
                          Utilice su logo en las facturas que genere.
                        </Typography>
                        <input
                          accept="image/*"
                          style={{ display: "none" }}
                          id="raised-button-file"
                          type="file"
                          onChange={handleFileUpload}
                        />
                        <label htmlFor="raised-button-file">
                          <StyledButton
                            className="mb-4 me-4"
                            variant="contained"
                            component="span"
                          >
                            {label}
                          </StyledButton>
                        </label>
                        <StyledButton
                          disabled={!uploadFile || loadingFile}
                          onClick={saveFileStorage}
                          className="mb-4 me-4"
                          variant="contained"
                          component="span"
                        >
                          {loading ? (
                            <CircularProgress size={24} />
                          ) : (
                            "Subir archivo"
                          )}
                        </StyledButton>
                      </Grid>
                    </Grid>
                  </CardContent>
                </Card>
                <Divider style={{ marginBottom: "16px", width: "100%" }} />
                <Card>
                  <CardHeader
                    title={
                      <span style={{ fontSize: "0.9rem" }}>
                        <Apartment fontSize="small" /> Datos Empresa
                      </span>
                    }
                    style={{ paddingBottom: 9, paddingTop: 9 }}
                  />
                  <CardContent>
                    <Grid container spacing={2}>
                      <Grid item xs={12} md={4}>
                        <Typography variant="h6">RUC: *</Typography>
                        <TextField
                          margin="dense"
                          name="ruc"
                          label="Ruc"
                          id="ruc"
                          variant="outlined"
                          size="medium"
                          required
                          fullWidth
                          value={values.ruc}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          error={touched.ruc && Boolean(errors.ruc)}
                          helperText={touched.ruc && errors.ruc}
                        />
                        <Typography variant="h6">Dirección: *</Typography>
                        <TextField
                          margin="dense"
                          name="direccion_matriz"
                          label="Dirección"
                          id="direccion_matriz"
                          variant="outlined"
                          size="medium"
                          required
                          fullWidth
                          value={values.direccion_matriz}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          error={
                            touched.direccion_matriz &&
                            Boolean(errors.direccion_matriz)
                          }
                          helperText={
                            touched.direccion_matriz && errors.direccion_matriz
                          }
                        />
                        <Typography variant="h6">Establecimiento: *</Typography>
                        <TextField
                          select
                          label="Establecimiento"
                          required
                          fullWidth
                          variant="outlined"
                          size="medium"
                          margin="dense"
                          value={values.establecimiento}
                          onChange={(e) =>
                            setFieldValue("establecimiento", e.target.value)
                          }
                          onBlur={handleBlur}
                          error={
                            touched.establecimiento &&
                            Boolean(errors.establecimiento)
                          }
                          helperText={
                            touched.establecimiento && errors.establecimiento
                          }
                        >
                          <MenuItem value="001">001 (Matriz)</MenuItem>
                        </TextField>
                      </Grid>
                      <Grid item xs={12} md={4}>
                        <Typography variant="h6">Razón Social: *</Typography>
                        <TextField
                          margin="dense"
                          name="razon_social"
                          label="Razón Social"
                          id="razon_social"
                          variant="outlined"
                          size="medium"
                          required
                          fullWidth
                          value={values.razon_social}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          error={
                            touched.razon_social && Boolean(errors.razon_social)
                          }
                          helperText={
                            touched.razon_social && errors.razon_social
                          }
                        />
                        <Typography variant="h6">Teléfono: *</Typography>
                        <TextField
                          margin="dense"
                          name="phones"
                          label="Teléfono"
                          id="phones"
                          variant="outlined"
                          size="medium"
                          required
                          fullWidth
                          value={values.phones}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          error={touched.phones && Boolean(errors.phones)}
                          helperText={touched.phones && errors.phones}
                        />
                        <Typography variant="h6">IVA: *</Typography>
                        <TextField
                          margin="dense"
                          name="iva"
                          label="IVA (%)"
                          id="iva"
                          type="number"
                          variant="outlined"
                          size="medium"
                          required
                          value={values.iva}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          error={touched.iva && Boolean(errors.iva)}
                          helperText={touched.iva && errors.iva}
                        />
                      </Grid>
                      <Grid item xs={12} md={4}>
                        <Typography variant="h6">Nombre Comercial:</Typography>
                        <TextField
                          margin="dense"
                          name="nombre_comercial"
                          label="Nombre Comercial"
                          id="nombre_comercial"
                          variant="outlined"
                          size="medium"
                          fullWidth
                          value={values.nombre_comercial}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          error={
                            touched.nombre_comercial &&
                            Boolean(errors.nombre_comercial)
                          }
                          helperText={
                            touched.nombre_comercial && errors.nombre_comercial
                          }
                        />
                        <Typography variant="h6">Email:</Typography>
                        <TextField
                          margin="dense"
                          name="correo"
                          label="Email"
                          id="correo"
                          variant="outlined"
                          size="medium"
                          fullWidth
                          value={values.correo}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          error={touched.correo && Boolean(errors.correo)}
                          helperText={touched.correo && errors.correo}
                        />
                      </Grid>
                    </Grid>
                    <Grid container spacing={2} style={{ margin: 5 }}>
                      <Grid item xs={12} md={4}>
                        <Grid container direction="column">
                          <FormControlLabel
                            label="Obligado Contabilidad"
                            control={
                              <Checkbox
                                name="obligado_contabilidad"
                                checked={values.obligado_contabilidad}
                                onChange={handleChange}
                              />
                            }
                          />
                          <FormControlLabel
                            label="Micro Empresa"
                            control={
                              <Checkbox
                                name="microenterprise"
                                checked={values.microenterprise}
                                onChange={handleChange}
                              />
                            }
                          />
                        </Grid>
                      </Grid>
                      <Grid item xs={12} md={4}>
                        <Grid container direction="column">
                          <FormControlLabel
                            label="Contribuyente Especial"
                            control={
                              <Checkbox
                                name="contribuyente_especial"
                                checked={values.contribuyente_especial}
                                onChange={handleChange}
                              />
                            }
                          />
                        </Grid>
                      </Grid>
                      <Grid item xs={12} md={4}>
                        <Grid container direction="column">
                          <FormControlLabel
                            label="Agente de Retención"
                            control={
                              <Checkbox
                                name="agente_retencion"
                                checked={values.agente_retencion}
                                onChange={handleChange}
                              />
                            }
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                  </CardContent>
                </Card>
                <Divider style={{ marginBottom: "16px", width: "100%" }} />
                <Card>
                  <CardHeader
                    title={
                      <span style={{ fontSize: "0.9rem" }}>
                        <VpnKey fontSize="small" /> Firma Electrónica
                      </span>
                    }
                    style={{ paddingBottom: 9, paddingTop: 9 }}
                  />
                  <CardContent>
                    <Box
                      sx={{
                        width: "100%",
                        display: "flex",
                        flexDirection: "column",
                      }}
                    >
                      <Box
                        display="flex"
                        alignItems="center"
                        justifyContent="space-between"
                        mb={2}
                      >
                        {configFacturacion?.sign &&
                        configFacturacion.sign.trim() !== "" ? (
                          <Typography color="success.main">
                            ✔ Firma agregada
                          </Typography>
                        ) : (
                          <Typography color="warning.main">
                            ⚠ Firma no agregada
                          </Typography>
                        )}
                      </Box>
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <Grid item xs={12} md={8}>
                          <Card
                            style={{
                              height: "100%",
                              display: "flex",
                              flexDirection: "column",
                            }}
                          >
                            <Divider />
                            <CardContent>
                              <div className={clsx(classes.imageRoot)}>
                                <div
                                  className={clsx({
                                    [classes.dropZone]: true,
                                    [classes.dragActive]: isDragActive,
                                  })}
                                  {...getRootProps()}
                                >
                                  <input
                                    {...getInputProps()}
                                    accept=".p12,.pfx,.cer"
                                    type="file"
                                  />
                                  <div
                                    style={{
                                      textAlign: "center",
                                      display: "flex",
                                      flexDirection: "column",
                                      alignItems: "center",
                                      cursor: "pointer",
                                    }}
                                  >
                                    <Box mt={2} color="gray">
                                      <CloudUpload />
                                      <Typography>
                                        <b>Elige</b> o arrastra tus archivos
                                        aquí
                                      </Typography>
                                    </Box>
                                    <Typography
                                      gutterBottom
                                      variant="h5"
                                      startIcon={<CloudUpload />}
                                      style={{
                                        border: "1px solid #ccc",
                                        borderRadius: "7px",
                                        padding: "3px",
                                        backgroundColor: "#092147",
                                        color: "#fff",
                                        marginTop: "10px",
                                        width: "60%",
                                      }}
                                    >
                                      {configFacturacion?.sign !== ""
                                        ? "Seleccionar archivo para actualizar"
                                        : "Seleccionar archivo para cargar"}
                                    </Typography>
                                  </div>
                                </div>
                                {files.length > 0 && (
                                  <>
                                    <PerfectScrollbar
                                      options={{ suppressScrollX: true }}
                                    >
                                      <List className={classes.list}>
                                        {files.map((file1, i) => (
                                          <ListItem
                                            divider={i < files.length - 1}
                                            key={file1.name}
                                          >
                                            <ListItemIcon>
                                              <FileCopy />
                                            </ListItemIcon>
                                            <ListItemText
                                              primary={file1.name}
                                              primaryTypographyProps={{
                                                variant: "h5",
                                              }}
                                              secondary={bytesToSize(
                                                file1.size
                                              )}
                                            />
                                          </ListItem>
                                        ))}
                                      </List>
                                    </PerfectScrollbar>
                                    <div className={classes.actions}>
                                      <StyledButton
                                        onClick={handleRemoveAll}
                                        size="small"
                                      >
                                        Eliminar
                                      </StyledButton>
                                    </div>
                                  </>
                                )}
                              </div>
                            </CardContent>
                          </Card>
                        </Grid>
                      </div>
                    </Box>
                  </CardContent>
                </Card>
                <Box display="flex" justifyContent="flex-end">
                  <CardActions>
                    <StyledButton
                      color="primary"
                      startIcon={<Save fontSize="small" />}
                      // type="submit"
                      onClick={() => {
                        if (files.length > 0) {
                          handleOpenDialog();
                        } else {
                          handleSubmit();
                        }
                      }}
                    >
                      Guardar Cambios
                    </StyledButton>
                  </CardActions>
                </Box>
              </Box>
              <Dialog
                open={openDialogPass}
                onClose={handleCloseDialog}
                aria-labelledby="delete-item-dialog"
              >
                <DialogTitle
                  style={{ cursor: "move" }}
                  id="draggable-dialog-title"
                >
                  <h5>Guardar firma</h5>
                </DialogTitle>
                <Divider />
                {loading ? (
                  <Box display="flex" justifyContent="center" my={5}>
                    <CircularProgress />
                  </Box>
                ) : (
                  <DialogContent>
                    <DialogContentText>
                      Ingrese la contraseña de su firma electrónica:
                    </DialogContentText>
                    <TextField
                      margin="dense"
                      name="signPass"
                      label="Contraseña"
                      id="signPass"
                      type="password"
                      variant="outlined"
                      size="medium"
                      fullWidth
                      autoFocus
                      sx={{ mt: 1 }}
                      value={values.signPass}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={touched.signPass && Boolean(errors.signPass)}
                      helperText={touched.signPass && errors.signPass}
                    />
                  </DialogContent>
                )}
                <DialogActions>
                  <StyledButton
                    variant="outlined"
                    color="primary"
                    type="submit"
                    onClick={handleSubmit}
                    startIcon={<VpnKey fontSize="small" />}
                  >
                    Continuar
                  </StyledButton>
                </DialogActions>
              </Dialog>
            </form>
          )}
        </Formik>
      )}
    </div>
  );
};

export default ConfigEmpresa;
